'use strict';
(function () {
  angular.module('pentaApp').factory('client.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/client', null, { query: { isArray: true, cache: true } });
  }
})();